import Picture from 'components/picture';

export const RewardImage = Picture.withConfig({
  width: '124px',
  height: '100px',
  marginBottom: '$4',
  alignSelf: 'center',
});
